//DOM transforms on window sizes
(function($) {
	$(function() {
		//Transforms for loaded window
		function mainTransforms(windowWidth) {
			
			if (windowWidth != winWidth) {
				winWidth = windowWidth;
			}
			if (winWidth < cssBreakPoints.md) {
				transformFromMdToSm();
				if (winWidth >= cssBreakPoints.sm) {
					transformFromMdOnlyToSm();
				} else {
					transformFromMdOnlyToXs();
				}
			}
		}
		mainTransforms(winWidth);
		function onResizeTransforms() {
			var newWinWidth = $window.outerWidth(),
			    newWinHeight = $window.height(),
			    objToHandler = {
			    	width: false,
			    	height: false
			    };
			//console.log(newWinWidth);
			//alert(newWinWidth);
			if (newWinWidth != winWidth) {
				if (winWidth >= cssBreakPoints.lg) {
					if (newWinWidth < cssBreakPoints.lg) {
						//lg to md
						//do nothing
						if (newWinWidth < cssBreakPoints.md) {
							//lg to sm or xs
							transformFromMdToSm();
							if (newWinWidth < cssBreakPoints.sm) {
								//lg to xs
								transformFromMdOnlyToXs();
							} else {
								//lg to sm
								transformFromMdOnlyToSm();
							}
						}
					}
				} else if (winWidth >= cssBreakPoints.md) {
					if (newWinWidth < cssBreakPoints.md) {
						//md to sm or xs
						transformFromMdToSm();
						if (newWinWidth < cssBreakPoints.sm) {
							//lg to xs
							transformFromMdOnlyToXs();
						} else {
							//lg to sm
							transformFromMdOnlyToSm();
						}
					} else if (newWinWidth >= cssBreakPoints.lg) {
						//md to lg
					}
				} else if (winWidth >= cssBreakPoints.sm) {
					if (newWinWidth < cssBreakPoints.sm) {
						//sm to xs
						transformFromSmToXs();
					} else if (newWinWidth >= cssBreakPoints.md) {
						//sm to md
						transformFromSmToMd();
						transformFromSmOnlyToMd();
					}
				} else {
					if (newWinWidth >= cssBreakPoints.sm) {
						if (newWinWidth >= cssBreakPoints.md) {
							//sm to md
							transformFromXsOnlyToMd();
							transformFromSmToMd();
						} else {
							//xs to sm
							transformFromXsToSm();
						}
					}
				}
				winWidth = newWinWidth;
				objToHandler.width = true;
			}

			if (newWinHeight != winHeight) {
				winHeight = newWinHeight;
				objToHandler.height = true;
			}

			if (objToHandler.width || objToHandler.height) {
				$window.trigger('custom.onresize', objToHandler);
			}
		}
		var winResizeTimer = setInterval(onResizeTransforms, 500);
		// $window.on('resize', function() {
		// 	onResizeTransforms();
		// });

		// $window.on('orientationchange',function() {
		// 	//alert(window.orientation);
		// 	setTimeout(function() {$window.trigger('resize');},1000);
		// 	//$body.toggleClass('body-arabic')

		// });

		function transformFromMdToSm() {
			$('.md-to-sm').each(function(){
				$(this).appendTo($(this).data('md-to-sm'));
			});
		}
		function transformFromSmToMd() {
			$('.md-to-sm').each(function(){
				$(this).appendTo($(this).data('sm-to-md'));
			});
		}
		function transformFromMdOnlyToSm() {
			$('.md-to-sm-only').each(function() {
				$(this).appendTo($(this).data('md-to-sm-only'));
			});
			turnOnSmListeners($);
		}
		function transformFromSmOnlyToMd() {
			$('.md-to-sm-only').each(function() {
				$(this).appendTo($(this).data('sm-to-md-only'));
			});
			turnOffSmListeners($);
		}
		function transformFromSmToXs() {
			transformFromSmOnlyToMd();
			transformFromMdOnlyToXs();
		}
		function transformFromXsToSm() {
			transformFromXsOnlyToMd();
			transformFromMdOnlyToSm();
			turnOffXsListeners($);
		}
		function transformFromMdOnlyToXs() {
			$('.md-to-xs-only').each(function(){
				$(this).appendTo($(this).data('md-to-xs-only'));
			});
			turnOnXsListeners($);
		}
		function transformFromXsOnlyToMd() {
			$('.md-to-xs-only').each(function(){
				$(this).appendTo($(this).data('xs-to-md-only'));
			});
			turnOffXsListeners($);
		}
	});
})(jQuery)